<template>
  <div>
    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
<!--        <th class="text-center">功能</th>-->
<!--        <th>分類</th>-->
        <th>問題</th>
        <th>回答</th>
<!--        <th>分數</th>-->
<!--        <th>行動</th>-->
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in this.datas" :key="index">
<!--        <td class="text-center" width="320px">-->
<!--          <a class="btn btn-info thisBtnEdit" @click="DataItem_Insert(answer)"><i class="fas fa-star"></i></a>-->
<!--          <a class="btn btn-info thisBtnEdit" @click="DataItem_Insert(answer)"><i class="fa fa-comment-dots"></i></a>-->
<!--        </td>-->
<!--        <td width="220px">-->
<!--          {{answer.questionGroup}}-->
<!--        </td>-->
        <td width="500px">
          {{item.QuestionText}}
        </td>
        <td width="420px">
          <span v-html="item.Answers"></span>
        </td>
<!--        <td width="100px">-->
<!--          {{answer.Score}}-->
<!--        </td>-->
<!--        <td>-->
<!--          {{answer.action}}-->
<!--        </td>-->
      </tr>

      </tbody>
    </table>
  </div>
</template>

<script>
/**

 **/

import arrayUtil from "../../util/arrayUtil";
import util from "../../util/util";
export default {
  //name: "contentEdit",
  props: ["datas"],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
    };
  },
  methods: {
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
    gotoHelpMemoEdit(item){
      this.$router.push({
        path: "/AppContentHelpMemoEdit",
        // path: item.url,
      });
    },
    submit(){
      for (let i = 0; i < this.datas.Details.length; i++) {
        let item = this.datas.Details[i];

        if (item.Year===""){
          util.showErrorMessage("第"+i+1+" 行，「年」為必填欄位")
          return;
        }
        if (item.Month===""){
          util.showErrorMessage("第"+i+1+" 行，「月」為必填欄位")
          return;
        }
        if (item.Type===""){
          util.showErrorMessage("第"+i+1+" 行，「幣別」為必填欄位")
          return;
        }
        if (item.Rate===""){
          util.showErrorMessage("第"+i+1+" 行，「匯率」為必填欄位")
          return;
        }
      }

      // apiGPK.api_Save_datas(this.datas.SystemId,"",this.datas).then((data)=>{
      //   util.ShowMessage('儲存成功')
      // })
    },

    DataItem_MoveUp(item){
      arrayUtil.orderMove(false,item.Id,this.datas,"Id","OrderKey")
    },
    DataItem_MoveDown(item){
      arrayUtil.orderMove(true,item.Id,this.datas,"Id","OrderKey")
    },
    DataItem_AddLast(){
      let newItem={
        Id:util.uuid(),
        Year:0,
        Moneth:0,
        Type:"",
        Rate:0,
        OrderKey:0,
      }

      arrayUtil.orderAppendLast(newItem,this.datas,"OrderKey")
    },
    DataItem_Insert(currentItem){
      // let newItem={
      //   Id:util.uuid(),
      //   imgSrc:"",
      //   date:"2021-10-20",
      //   text:"",
      //   desc:"",
      // }
      //
      // arrayUtil.orderInsert(newItem,currentItem,this.datas,"Id","OrderKey")
      //
      this.$router.push({
        path: "/contentDetailEdit",
        // path: item.url,
      });
    },
    DataItem_Remove(item){
      arrayUtil.removeByPredicate(this.datas,s => s.Id===item.Id);
    },

  },
  mounted() {
    //this.loadData()
  },
}
</script>


<style scoped>
#tblMain{
  width: 1000px;
}
.thisBtnEdit{
  color: white !important;
  margin: 5px;
  width: 40px;
}
</style>
